import { render, staticRenderFns } from "./__TemBichPreview.vue?vue&type=template&id=72634896&"
import script from "./__TemBichPreview.vue?vue&type=script&lang=js&"
export * from "./__TemBichPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports